import * as React from "react";

function SvgChat({ title, titleId, ...props }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <g fill="none" fillRule="evenodd">
        <path d="M0 0h24v24H0z" />
        <path
          fill="currentColor"
          d="M14 1.25c4.813 0 8.75 3.552 8.75 7.99 0 2.373-1.139 4.557-3.053 6.056l-.146.109-.001 2.462a.75.75 0 01-.987.712l-.094-.04-2.921-1.438-.103.018a9.59 9.59 0 01-1.082.104L14 17.23c-.425 0-.85-.03-1.273-.089a5.653 5.653 0 01-5.432 5.413l-.11.002-.102.007a5.663 5.663 0 01-2.1-.402l-.043-.02-2.784.593a.75.75 0 01-.904-.789l.014-.098.582-2.793-.019-.043a5.658 5.658 0 01-.397-1.795l-.008-.312a5.655 5.655 0 014.167-5.456A7.27 7.27 0 015.25 9.24c0-4.438 3.937-7.99 8.75-7.99zm-6.922 11.5a4.154 4.154 0 00-3.767 5.91c.051.11.075.23.07.35l-.016.12-.396 1.897 1.893-.402a.76.76 0 01.358.012l.113.042c.467.216.969.344 1.489.376l.204.006.052-.003c2.224 0 4.04-1.75 4.149-3.947l.005-.207a4.154 4.154 0 00-4.154-4.154zm-1.94 3.545l.104.067.084.072a.802.802 0 01-1.132 1.132.802.802 0 01.944-1.272zm2.25 0l.104.067.084.072a.802.802 0 01-1.132 1.132.802.802 0 01.944-1.272zm2.25 0l.104.067.084.072a.802.802 0 01-1.132 1.132.802.802 0 01.944-1.272zM14 2.75c-4.017 0-7.25 2.917-7.25 6.49 0 .692.121 1.368.357 2.012l-.029-.002a5.656 5.656 0 015.502 4.346 7.6 7.6 0 001.42.134c.51 0 1.017-.05 1.52-.146a.745.745 0 01.36.02l.112.044 2.058 1.014.001-1.639c0-.249.123-.481.328-.621 1.801-1.226 2.871-3.113 2.871-5.162 0-3.573-3.233-6.49-7.25-6.49zm0 8.958l.107.007a.85.85 0 11-.214 0l.107-.007zm0-6.57a2.359 2.359 0 012.359 2.359c0 .79-.349 1.316-.977 1.777l-.15.105c-.323.217-.453.368-.477.582l-.005.083a.75.75 0 01-1.5 0c0-.8.353-1.334.992-1.802l.152-.107c.351-.237.465-.39.465-.638a.858.858 0 00-1.711-.108l-.007.108a.75.75 0 01-1.5 0A2.359 2.359 0 0114 5.138z"
        />
      </g>
    </svg>
  );
}

export default SvgChat;
